module.exports = __webpack_public_path__ + "static/media/locationIcon.399b3368.svg";